import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { money } from "../lib/api";

export default function ProductCard({ product, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: (index % 4) * 0.08 }}
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/product/${product.id}`} className="group block">
        <div className="overflow-hidden bg-[#f5f5f0] aspect-[4/5] mb-4">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        </div>
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="text-[11px] uppercase tracking-luxe text-[#999] mb-1">{product.category}</div>
            <h3 className="font-serif text-xl leading-tight">{product.name}</h3>
          </div>
          <div className="text-base font-medium whitespace-nowrap pt-1">{money(product.price)}</div>
        </div>
      </Link>
    </motion.div>
  );
}
